import React, { createContext, useState, useContext, useEffect, use } from 'react';
import { useMsal } from "@azure/msal-react";
import ApiProvider from './apiProvider';
import { get } from 'react-hook-form';

const EmployeeNumberContext = createContext();

export const EmployeeNumberProvider = ({ children }) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [employeeNumber, setEmployeeNumber] = useState({});

    const getUserNum = async () => {
        let result = await apiProvider.Get(
            `Employee/GetUserNumber`,
            null,
            "application/json",
            false
        );
        setEmployeeNumber({
            number : result,
            name : accounts[0].name
        });
    }
    
    useEffect(() => {
        getUserNum();
    }, []);

    return (
        <EmployeeNumberContext.Provider value={{ employeeNumber, setEmployeeNumber }}>
            {children}
        </EmployeeNumberContext.Provider>
    );
};

export const useEmployeeNumber = () => {
    const context = useContext(EmployeeNumberContext);
  
    if (!context) {
      throw new Error("useEmployeeNumber must be used within an EmployeeNumberProvider");
    }
  
    return context;  // Return the context containing employeeNumber and setEmployeeNumber
  };